import { useCallback } from 'react';

import { ROUTES } from '@/consts/routes';
import { selectClearAuth, useAuthStore } from '@/stores/useAuthStore';
import { useAuth as useClerkAuth } from '@clerk/react';

/** Safe wrapper — returns noop signOut when rendered outside ClerkProvider (mock mode). */
function useSafeClerkAuth() {
  try {
    return useClerkAuth();
  } catch {
    return { signOut: undefined };
  }
}

export const useAuth = () => {
  const clearAuth = useAuthStore(selectClearAuth);
  const { signOut } = useSafeClerkAuth();

  const logout = useCallback(() => {
    clearAuth();
    if (signOut) {
      void signOut({ redirectUrl: `${import.meta.env.VITE_BASE_URL}${ROUTES.auth.login}` });
    } else {
      window.location.href = ROUTES.auth.login;
    }
  }, [clearAuth, signOut]);

  return {
    logout
  };
};
